// src/favoritesService.js
// Centralized service for the favorite_tracks table
import { supabase } from './supabaseClient'

// Fetch all favorited day numbers for a user in a city
export async function fetchFavorites(userId, city) {
  const { data, error } = await supabase
    .from('favorite_tracks')
    .select('day_number')
    .eq('user_id', userId)
    .eq('city', city)
  return { data: (data || []).map(row => row.day_number), error }
}

// Favorite a track
export async function addFavorite(userId, city, dayNumber) {
  const { error } = await supabase
    .from('favorite_tracks')
    .insert({ user_id: userId, city, day_number: dayNumber })
  // Ignore unique-violation — already favorited is not an error from the caller's perspective
  if (error && error.code === '23505') return { error: null }
  return { error }
}

// Unfavorite a track
export async function removeFavorite(userId, city, dayNumber) {
  const { error } = await supabase
    .from('favorite_tracks')
    .delete()
    .eq('user_id', userId)
    .eq('city', city)
    .eq('day_number', dayNumber)
  return { error }
}
